class OurHistory {
    // 1. describe and create/initiate our object
    constructor() {
        this.section = document.querySelector('.our-history');
        if (this.section) {
            this.firstBg = this.section.getAttribute("data-first-image");
            this.secondBg = this.section.getAttribute("data-second-image");   
        }

        if (this.section && this.firstBg && this.secondBg) {
            this.events();
        }
    }

    // 2. events
    events() {
        this.handleBgChange(this.section, this.firstBg, this.secondBg);
    }

    // 3. methods (function, action...)
    handleBgChange(section, bg1, bg2) {

        const changeBackground = () => {
            if (section.style.backgroundImage === 'url("' + bg1 + '")') {
                section.style.backgroundImage = 'url("' + bg2 + '")';
            } else {
                section.style.backgroundImage = 'url("' + bg1 + '")';
            }
        };

        setInterval(changeBackground, 3200);

    }
}

export default OurHistory;
